
import axios from "axios";
import GLOBAL from "../Global.js";

export default class ReporteService {


    getFactura(person, venta) {
        console.log(venta)

        var url1 = GLOBAL.API_GET_FACTURA + "?hash=" + venta.hash + "&numero=" + venta.numero + "&prefijo=" + venta.prefijo + "&extended=true&validaciones=false";
        return axios
            .get(url1.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getFacturaWithEmpresa(person, venta) {
        console.log(venta)

        var url1 = GLOBAL.API_GET_FACTURA + "?hash=" + venta.hash + "&empresaid="+person.empresas+"&numero=" + venta.numero + "&prefijo=" + venta.prefijo + "&extended=true&validaciones=false";
        return axios
            .get(url1.trim(), {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaMovimientos(person, fechainicio, fechafin, documentos, filtros) {

        var url1 = GLOBAL.API_GET_REPORTE_VENTAS
            + "?fechainicio=" + fechainicio + ":00.000"
            + "&fechafin=" + fechafin + ":59.999"
            + "&tipo=" + documentos

        if (filtros != null && Object.keys(filtros).length !== 0) {
            url1 = url1 + "&search=" + encodeURIComponent(JSON.stringify(filtros));
        }

        return axios
            .get(url1, {
                timeout: 30000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaMovimientosConciliacion(person, fechainicio, fechafin, documentos, search) {

        var url1 = GLOBAL.API_GET_REPORTE_CONCILIACIONES
            + "?fechainicio=" + fechainicio + ":00.000"
            + "&fechafin=" + fechafin + ":59.999"
            + "&tipo=" + documentos

        if (search != null && Object.keys(search).length !== 0) {
            url1 = url1 + "&search[value]=" + encodeURIComponent(JSON.stringify(search));
        }

        return axios
            .get(url1, {
                timeout: 30000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaMovimientosDocumentos(person, fechainicio, fechafin, tipo) {
        var url1 = GLOBAL.API_GET_REPORTE_FACTURA_ELECTRONICA + "?fechainicio=" + fechainicio + ":00.000&fechafin=" + fechafin + ":59.999&estado=" + tipo;
        return axios
            .get(url1, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    verVentaCanastilla(person, fechainicio, fechafin) {
        var url1 = GLOBAL.API_GET_REPORTE_CANASTILLA + "?fechainicio=" + fechainicio + ":00.000&fechafin=" + fechafin + ":59.999";
        return axios
            .get(url1, {
                timeout: 30000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }



    getListaMovimientosPlaca(person, fechainicio, fechafin, documentos, tercero) {
        var url1 = GLOBAL.API_GET_REPORTE_VENTAS_PLACA + "?fechainicio=" + fechainicio + ":00.000&fechafin=" + fechafin + ":59.999" + "&tercerouniqueid=" + tercero+"&tipo=" + documentos + "&format=json";
        return axios
            .get(url1, {
                timeout: 30000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getListaMovimientosDespachos(person, fechainicio, fechafin, documentos, tercero) {
        var url1 = GLOBAL.API_GET_REPORTE_VENTAS_DESPACHOS + "?fechainicio=" + fechainicio + ":00.000&fechafin=" + fechafin + ":59.999&tipo=" + documentos + "&tercerouniqueid=" + tercero;
        return axios
            .get(url1, {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    convertirFacturaConciliada(person, request) {

        var url1 = GLOBAL.API_POST_CREAR_FACTURA;
        return axios
            .post(url1.trim(), request, {
                timeout: 60000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d)
            .catch((error) => console.log(error));
    }

    corterTurno(person, fechainicio, fechafin, tipo) {
        var url1 = GLOBAL.API_GET_REPORTE_CORTE + "?fechainicio=" + fechainicio + "&fechafin=" + fechafin;
        return axios
            .get(url1, {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    getTurnosPromotores(person, fechainicio, fechafin, tipo) {
        var url1 = GLOBAL.API_GET_REPORTE_TURNOS + "?fechainicio=" + fechainicio + "&fechafin=" + fechafin;
        return axios
            .get(url1, {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    reintentarEnvioFacturaMexico(person, request) {
        var url1 = GLOBAL.API_GET_FACTURA_REINTENTAR_MX;
        return axios
            .post(url1.trim(), request, {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    reintentarNotaCreditoMexico(person, request) {
        var url1 = GLOBAL.API_CONSULTA_NOTACREDITO_MEXICO_ELECTRONICA;
        return axios
            .post(url1.trim(), request, {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }

    reintentarEnvioFacturaColombia(person, request) {
        var url1 = GLOBAL.API_GET_FACTURA_REINTENTAR_CO;
        return axios
            .post(url1.trim(), request, {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }


    reintentarConsultaFactura(person, request) {
        var url1 = GLOBAL.API_GET_FACTURA_CONSULTA_MX;
        return axios
            .post(url1.trim(), request, {
                timeout: 15000,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: "Basic " + person.token,
                    Environment: person.empresas
                },
            }).then(d => d.data)
            .catch((error) => console.log(error));
    }


}